export interface DebouncerOptions {
  /** Time in milliseconds until the next possible `callback` call
   * @default 200
   */
  cooldown?: number
  /** Immediatly run `callback` on the first `debounce` call
   * @default true
   */
  immediate?: boolean
}

export function useDebouncer() {
  const funcTimeoutIds = new WeakMap<() => void, number>()

  /**
   * Delay `callback` call if it was already called under the last `options.cooldown` milliseconds.
   */
  function debounce(callback: () => void, options?: DebouncerOptions) {
    const cooldown = options?.cooldown ?? 200
    const immediate = !options || options.immediate

    if (funcTimeoutIds.has(callback)) {
      clearTimeout(funcTimeoutIds.get(callback))
    } else if (immediate) {
      callback()
    }

    const id = setTimeout(() => {
      callback()
      funcTimeoutIds.delete(callback)
    }, cooldown)

    funcTimeoutIds.set(callback, id)
  }

  return { debounce }
}
